var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { is } from "./is";
export function injectJs(src) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!is.string(src)) {
            return;
        }
        return new Promise(resolve => {
            const script = document.createElement("script");
            script.src = src;
            document.head.appendChild(script);
            script.onload = () => {
                resolve();
            };
        });
    });
}
/**
 * 全局设置分享
 * @param option 分享参数设置
 * @param onTrigger 点击分享图标或按钮时触发
 */
export function share(option, onTrigger = () => { }) {
    // 分享配置
    const config = {
        title: option.title || "",
        desc: option.desc || "",
        link: option.link || "",
        imgUrl: option.imgUrl || "",
        dataUrl: option.dataUrl || "",
        type: is.undefined(option.type) ? option.type : "link",
        miniProgramPath: option.miniProgramPath || "",
        miniProgramId: option.miniProgramId || ""
    };
    //分享给车轮好友的内容
    window["CHELUN_SHARE_DATA_CLMESSAGE"] = {
        title: config.title,
        desc: config.desc,
        link: config.link,
        imgUrl: config.imgUrl,
        type: config.type,
        dataUrl: config.dataUrl
    };
    // 分享微信朋友圈配置
    window["CHELUN_SHARE_DATA_WXTIMELINE"] = {
        title: config.title,
        link: config.link,
        imgUrl: config.imgUrl,
        type: config.type,
        miniProgramPath: config.miniProgramPath,
        miniProgramId: config.miniProgramId
    };
    // 分享微信好友配置
    window["CHELUN_SHARE_DATA_WXMESSAGE"] = {
        title: config.title,
        desc: config.desc,
        link: config.link,
        imgUrl: config.imgUrl,
        type: config.type,
        dataUrl: config.dataUrl,
        miniProgramPath: config.miniProgramPath,
        miniProgramId: config.miniProgramId
    };
    //分享到QQ的内容
    window["CHELUN_SHARE_DATA_QQ"] = {
        title: config.title,
        desc: config.desc,
        link: config.link,
        imgUrl: config.imgUrl
    };
    //分享到新浪微博的内容
    window["CHELUN_SHARE_DATA_SINA"] = {
        title: config.title,
        desc: config.desc,
        link: config.link,
        imgUrl: config.imgUrl
    };
    //分享到新浪微博的内容
    window["CHELUN_SHARE_DATA_SMS"] = {
        title: config.title
    };
    // 客户端内设置
    if (!is.function(onTrigger)) {
        onTrigger = () => { };
    }
    document.addEventListener("onShareClick", onTrigger);
    // 微信平台的分享需要单独定制
    if (is.weixin()) {
        const schema = window.location.protocol;
        const wxsdk = `${schema}//res.wx.qq.com/open/js/jweixin-1.4.0.js`;
        const wxconfig = `${schema}//front.chelun.com/new_bridge_v2.js`;
        // 检测微信平台下是否存在相关JS注入
        const check = document.querySelector(`script[src="${wxsdk}"]`);
        if (!is.element(check)) {
            (() => __awaiter(this, void 0, void 0, function* () {
                yield injectJs(wxsdk);
                yield injectJs(wxconfig);
            }))();
        }
        let times = 0;
        let interval = window.setInterval(() => {
            // 最多检测50次（即5秒之内必须检测出来，否则放弃），
            if (times > 50 || window.__WXREADY__ === true) {
                window.clearInterval(interval);
            }
            // 检测到微信配置正确，开始设置微信分享相关
            if (window.__WXREADY__ === true) {
                wx.updateAppMessageShareData({
                    title: config.title,
                    desc: config.desc,
                    link: config.link,
                    imgUrl: config.imgUrl,
                    success: onTrigger
                });
                wx.updateTimelineShareData({
                    title: config.title,
                    link: config.link,
                    imgUrl: config.imgUrl,
                    success: onTrigger
                });
            }
            // 检测次数自增+1
            times++;
        }, 100);
    }
}
